import { useEffect, useState } from "react";
import { shiftMasterList } from "../services/shiftService";

const useShiftMasterList = () => {
    const [shiftData, setShiftData] = useState([]);

    const fetchShiftMasterList = async () => {
        const para = {
            p_companyid: localStorage.getItem("companyid"),
            p_plantid: 1,
        };

        try {
            const data = await shiftMasterList(para);

            // Check if data is valid and assign directly
            if (Array.isArray(data)) {
                setShiftData(data);
            } else {
                setShiftData([]);
            }
        } catch (error) {
            console.error("Error fetching shift master list:", error.message);
            setShiftData([]);
        }
    };

    useEffect(() => {
        fetchShiftMasterList();
    }, []); // ✅ Only run on mount

    const refreshList = async () => {
        await fetchShiftMasterList();
    }

    return { shiftData, setShiftData,refreshList };
};

export default useShiftMasterList;
